import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { CouponFormValues } from "src/models/Coupon.model";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMSelectSearchable from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import { handleValidNumber } from "src/utils/validations/numberInput";
import useStudents from "src/hooks/useStudents";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

type Props = {
  formikProps: FormikProps<CouponFormValues>;
  onClose: () => void;
  formType?: string;
};

const couponTypeOption = [
  {
    label: "Referral",
    value: "REFERRAL",
  },
  {
    label: "Scholarship",
    value: "SCHOLARSHIP",
  },
];
const typeOption = [
  {
    label: "Percentage",
    value: "PERCENTAGE",
  },
  {
    label: "Fixed",
    value: "FIXED",
  },
];

const CouponForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  // Coupon Code Auto generate Function
  const generateCouponCode = () => {
    const generatedCode = uuidv4().substr(0, 5).toUpperCase(); // Generate a UUID and take the first 4 characters
    const newCouponCode = `GD-${generatedCode}`;
    setFieldValue("coupon_code", newCouponCode);
  };

  const { students, isDataLoading } = useStudents();
  const studentOption = students?.map((student) => {
    return {
      label: student?.name,
      value: student?._id,
    };
  });

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="xl:flex justify-between items-center">
        <div className="text-xl font-medium"> {formType} Coupon </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="grid md:grid-cols-2 xs:grid-cols-1 gap-4">
        <div className=" relative ">
          <ATMTextField
            disabled={formType === "Update" ? true : false}
            name="coupon_code"
            value={values?.coupon_code}
            onChange={(e) => {
              setFieldValue("coupon_code", e.target.value);
            }}
            label=" Coupon Code"
            placeholder="Enter Coupon Code"
            onBlur={handleBlur}
          />
          <div className="absolute top-7 right-2">
            <button
              disabled={formType === "Update" ? true : false}
              className="bg-primary-dark p-1 text-white font-semibold rounded-md text-[15px]"
              type="button"
              onClick={() => {
                generateCouponCode();
              }}
            >
              Generate
            </button>
          </div>
        </div>
        {/*Coupon Type  */}
        <ATMSelectValue
          name="coupon_type"
          value={values?.coupon_type}
          onChange={(value) => setFieldValue("coupon_type", value)}
          options={couponTypeOption}
          label=" Coupon Type "
        />
        <div>
          <ATMSelectValue
            name="type"
            value={values?.type}
            onChange={(value) => {
              setFieldValue("type", value);
              setFieldValue("maxDiscountAmount", "");
            }}
            options={typeOption}
            label="Discount Type "
          />
        </div>
        <div>
          <ATMTextField
            name="discountAmount"
            value={values?.discountAmount}
            onChange={(e) => {
              handleValidNumber(e) &&
                setFieldValue("discountAmount", e.target.value);
            }}
            label="Discount Amount"
            placeholder="Enter Discount Amount"
            onBlur={handleBlur}
          />
        </div>
        {values?.type === "PERCENTAGE" ? (
          <div>
            <ATMTextField
              name="maxDiscountAmount"
              value={values?.maxDiscountAmount}
              onChange={(e) => {
                handleValidNumber(e) &&
                  setFieldValue("maxDiscountAmount", e.target.value);
              }}
              label="Max Discount Amount"
              placeholder="Enter Max Discount Amount"
              onBlur={handleBlur}
            />
          </div>
        ) : null}
        <div>
          <ATMTextField
            name="max_apply_count"
            value={values?.max_apply_count}
            onChange={(e) => {
              handleValidNumber(e) &&
                setFieldValue("max_apply_count", e.target.value);
            }}
            label="Max Apply Count"
            placeholder="Enter Max Apply Count"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMSelectSearchable
            name="Student_name"
            value={values.Student_name}
            isLoading={isDataLoading}
            onChange={(newValue) => {
              setFieldValue("Student_name", newValue);
            }}
            label="Students"
            placeholder="Select Student"
            options={studentOption}
          />
        </div>

        <div>
          <ATMDatePicker
            name="vaild_from"
            value={values.vaild_from}
            onChange={(newValue) => setFieldValue("vaild_from", newValue)}
            label="Valid From"
          />
        </div>
        <div>
          <ATMDatePicker
            name="valid_till"
            value={values.valid_till}
            onChange={(newValue) => setFieldValue("valid_till", newValue)}
            label="Valid Till"
          />
        </div>
        <div>
           <ATMTextField
            type="time"
            name="startTime"
            value={moment(values?.startTime, "HH:mm").format("HH:mm")}
            onChange={(e) => {
              let time = moment(e.target.value, "HH:mm");
              setFieldValue("startTime", time);
            }}
            label="Start Time"
            onBlur={handleBlur}
            required
            placeholder="Please Start Time"
          />
        </div>
        <div>
           <ATMTextField
            type="time"
            name="endTime"
            value={moment(values?.endTime, "HH:mm").format("HH:mm")}
            onChange={(e) => {
              let time = moment(e.target.value, "HH:mm");
              setFieldValue("endTime", time);
            }}
            label="End Time"
            onBlur={handleBlur}
            required
            placeholder="Please End Time"
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default CouponForm;
